<template>
  <ul class="clase-breadcrumb">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Clientes</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Administrar Pagos de Clientes</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-center flex-column lg:justify-content-center lg:flex-row"
    >
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>ADMINISTRAR PAGOS DE CLIENTES</strong>
      </span>
    </div>
    <div class="col-12">
      <div class="card p-fondo">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-3">
            <span><strong>SUCURSAL:</strong></span>
            <Dropdown
              v-model="sucursalSelected"
              :options="sucursales"
              optionLabel="nombre"
              optionValue="id"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-6">
            <span><strong>CLIENTE:</strong></span>
            <Dropdown
              v-model="clienteSelected"
              :options="clientes"
              optionLabel="nombre"
              optionValue="id"
              :filter="true"
              @change="BuscarFiltro"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-3">
            <span><strong>TIPO DE PAGO: </strong></span>
            <Dropdown
              v-model="tipoPagoSelected"
              :options="tipo_pagos"
              optionLabel="nombre"
              optionValue="id"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-3" v-show="false">
            <span><strong>M&Eacute;TODO DE PAGO: </strong></span>
            <Dropdown
              v-model="metodoPagoSelected"
              :options="metodo_pagos"
              optionLabel="nombre"
              optionValue="id"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-3">
            <span><strong>FECHA INICIO: </strong></span>
            <InputText
              v-model="fecha_inicio"
              placeholder="Fecha Inicio"
              type="date"
            />
          </div>
          <div class="field col-12 md:col-3">
            <span><strong>FECHA FIN: </strong></span>
            <InputText
              v-model="fecha_fin"
              placeholder="Fecha Fin"
              type="date"
            />
          </div>
          <div class="field col-12 md:col-3">
            <span><strong>ESTADO: </strong></span>
            <Dropdown
              v-model="estadoSelected"
              :options="estados"
              optionLabel="label"
              optionValue="value"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-3">
            <span><strong>ACCIONES: </strong></span>
            <Button
              label="APLICAR FILTROS"
              icon="pi pi-search"
              class="p-button-warning"
              style="font-weight: bold"
              v-tooltip.top="'Aplicar los filtros'"
              :loading="enviando"
              :disabled="enviando"
              @click="BuscarFiltro"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="pago_clientes"
        key="id"
        :value="pago_clientes"
        responsiveLayout="scroll"
        :loading="enviando"
        class="p-datatable-sm white-space-nowrap"
        :filters="buscar"
        responsive="true"
        stripedRows
        showGridlines
        :rows="50"
        :paginator="true"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[50, 100, 500, 1000, 5000, 10000]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Pagos de Clientes"
        selectionMode="single"
        @row-dblclick="NuevoPagoCliente($event.data)"
      >
        <template #header>
          <div
            class="flex flex-column md:flex-row md:justify-content-end md:align-items-end"
          >
            <span class="block mt-2 md:mt-0 p-input-icon-left mr-2">
              <i class="pi pi-search" />
              <InputText
                v-model="buscar['global'].value"
                placeholder="Buscar Pagos de CLientes..."
              />
            </span>
          </div>
        </template>
        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span
            class="flex align-items-center justify-content-center"
            style="
              background-color: #f8d7da;
              padding: 5px;
              border-radius: 5px;
              color: #721c24;
            "
          >
            Debe aplicar filtros para ver resultados en la tabla!</span
          >
        </template>
        <Column field="venta_id" header="Nº VENTA" class="text-right"></Column>
        <Column field="cliente_nombre" header="CLIENTE"></Column>
        <Column
          field="fecha_pago"
          header="FECHA VENTA"
          :sortable="true"
        ></Column>
        <Column
          class="text-right"
          field="total_venta"
          header="TOTAL VENTA"
          style="font-weight: bold"
        >
          <template #body="{ data }">
            <div>
              {{ convertirNumeroGermanicFormat(data.total_venta) }}
            </div>
          </template>
        </Column>
        <Column class="text-right" field="a_cuenta_efectivo" header="EFECTIVO">
          <template #body="{ data }">
            <div>
              {{ convertirNumeroGermanicFormat(data.a_cuenta_efectivo) }}
            </div>
          </template>
        </Column>
        <Column
          class="text-right"
          field="a_cuenta_metodo_pago"
          header="TRANSFERENCIAS"
        >
          <template #body="{ data }">
            <div>
              {{ convertirNumeroGermanicFormat(data.a_cuenta_metodo_pago) }}
            </div>
          </template>
        </Column>
        <Column class="text-right" field="saldo" header="SALDO">
          <template #body="{ data }">
            <div>
              <span :class="data.saldo == 0 ? 'text-success' : 'text-danger'">
                {{ convertirNumeroGermanicFormat(data.saldo) }}
              </span>
            </div>
          </template>
        </Column>
        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span :class="'product-badge ' + claseEstado[data.estado]">
              {{ estadoTexto(data.estado) }}
            </span>
          </template>
        </Column>
        <Column header="ACCIONES">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised"
              icon="pi pi-ellipsis-v"
              v-tooltip.top="'Ver Acciones'"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            >
            </Menu>
          </template>
        </Column>
        <ColumnGroup type="footer">
          <Row>
            <Column footer="TOTALES:" class="text-right" :colspan="6"> </Column>
            <Column class="text-right" :footer="total_saldo" />
          </Row>
        </ColumnGroup>
      </DataTable>
      <PagoCliente
        :show="pagoClienteDialog"
        :esdeodontologia="es_de_odontologia"
        :pago_cliente="{ ...pago_cliente }"
        @closeModal="cerrarModalPagoCliente"
        @actualizarListado="actualizarListado"
      />
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ClienteService from "@/service/ClienteService";
import SucursalService from "@/service/SucursalService";
import PagoCliente from "@/module/clientes/PagoCliente.vue";
import TipoPagoService from "@/service/TipoPagoService";
import MetodoPagoService from "@/service/MetodoPagoService";
import PagoClienteService from "@/service/PagoClienteService";
import VentaService from "@/service/VentaService";
import { sum } from "lodash";

export default {
  components: {
    PagoCliente,
  },
  data() {
    return {
      pago_clientes: [],
      pago_cliente: {},
      sucursales: [{ id: 0, nombre: "TODAS" }],
      sucursalSelected: 0,
      clientes: [{ id: 0, nombre: "TODOS" }],
      clienteSelected: 0,
      tipo_pagos: [{ id: 0, nombre: "TODOS" }],
      tipoPagoSelected: 0,
      metodo_pagos: [{ id: 0, nombre: "TODOS" }],
      metodoPagoSelected: 0,
      fecha_inicio: null,
      fecha_fin: null,
      enviando: false,
      buscar: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      pagoClienteDialog: false,
      claseEstado: [
        "",
        "status-instock",
        "status-outofstock",
        "status-instock",
      ],
      estados: [
        { label: "TODOS", value: 0 },
        { label: "PAGADO", value: 1 },
        { label: "PENDIENTE", value: 2 },
      ],
      estadoSelected: 2,
      parametros_sistema: {},
      es_de_odontologia: false,
    };
  },
  clienteService: null,
  sucursalService: null,
  tipoPagoService: null,
  metodoPagoService: null,
  pagoClienteService: null,
  ventaService: null,
  created() {
    this.clienteService = new ClienteService();
    this.sucursalService = new SucursalService();
    this.tipoPagoService = new TipoPagoService();
    this.metodoPagoService = new MetodoPagoService();
    this.pagoClienteService = new PagoClienteService();
    this.ventaService = new VentaService();
  },
  mounted() {
    this.datos_necesarios_reporte_pagos();
    this.BuscarFiltro();
  },
  computed: {
    total_saldo() {
      return sum(
        this.pago_clientes.map((pago) => {
          return parseFloat(pago.saldo || 0);
        })
      );
    },
  },
  methods: {
    datos_necesarios_reporte_pagos() {
      this.pagoClienteService
        .datos_necesarios_reporte_pagos()
        .then((data) => {
          this.sucursales = [
            { id: 0, nombre: "TODAS" },
            ...(data.sucursales || []),
          ];
          this.clientes = [
            { id: 0, nombre: "TODOS" },
            ...(data.clientes || []),
          ];
          this.tipo_pagos = [
            { id: 0, nombre: "TODOS" },
            ...(data.tipo_pagos || []),
          ];
          this.metodo_pagos = [
            { id: 0, nombre: "TODOS" },
            ...(data.metodo_pagos || []),
          ];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numero);
    },
    acciones(datos) {
      return [
        {
          label: "Registrar Pago",
          disabled: datos.estado == 1 ? true : false,
          /* visible: "Pago Proveedor Crear" in this.auth.user.permissions ? true : false, */
          icon: "pi pi-plus",
          command: () => {
            this.NuevoPagoCliente(datos);
          },
        },

        {
          label: "Ver Detalle de Pago",
          icon: "pi pi-eye",
          to: "pago_clientes/" + datos.id + "/detalle",
        },
        {
          label: "Imprimir Venta",
          icon: "pi pi-print",
          command: () => {
            this.imprimirVenta(datos.id);
          },
        },
      ];
    },
    imprimirVenta(id) {
      this.ventaService
        .imprimirVenta(id)
        .then(() => {})
        .catch((error) => console.log(error));
    },
    actualizarListado() {
      this.BuscarFiltro();
    },
    NuevoPagoCliente(datos) {
      this.pago_cliente = { ...datos };
      this.pagoClienteDialog = true;
    },
    cerrarModalPagoCliente() {
      this.pagoClienteDialog = false;
    },
    BuscarFiltro() {
      this.pago_clientes = [];
      this.enviando = true;
      this.cargarPagoClientes();
    },
    cargarPagoClientes() {
      let datos = {
        sucursal_id: this.sucursalSelected == 0 ? null : this.sucursalSelected,
        cliente_id: this.clienteSelected,
        tipo_pago_id: this.tipoPagoSelected,
        metodo_pago_id: this.metodoPagoSelected,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        estado: this.estadoSelected,
      };
      this.pagoClienteService
        .getAllPagoClientes(datos)
        .then((response) => {
          this.pago_clientes = response.pago_clientes;
          this.parametros_sistema = response.parametros_sistema ?? {};
          if (this.parametros_sistema.length > 0) {
            this.parametros_sistema.some((element) => {
              if (element.nombre === "Odontologia") {
                this.es_de_odontologia = true;
              }
            });
          }
          this.enviando = false;
        })
        .catch(() => {
          this.enviando = false;
        });
    },
    estadoTexto(estado) {
      let texto = "";
      switch (estado) {
        case 1:
          texto = "PAGADO";
          break;
        case 2:
          texto = "PENDIENTE";
          break;
      }
      return texto;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-fondo {
  background-color: #6abad0;
  border-radius: 0.5em;
  border: 1px solid #002236;
}
.text-success {
  color: #28a745;
  font-weight: bold;
  font-size: 1rem;
}
.text-danger {
  color: #dc3545;
  font-weight: bold;
  font-size: 1rem;
}
.clase-breadcrumb {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 500;
}
</style>
